import React from 'react';
import { WifiOff } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import useOnlineStatus from '../hooks/useOnlineStatus';

export default function OfflineBanner() {
  const { isOnline } = useOnlineStatus();

  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="fixed top-[calc(env(safe-area-inset-top)+3.5rem)] lg:top-24 left-0 right-0 z-[100] flex justify-center pointer-events-none"
        >
          <div className="mx-4 px-4 py-2 bg-stone-800/90 backdrop-blur-sm text-white text-xs font-medium rounded-full flex items-center gap-2 shadow-lg pointer-events-auto">
            <WifiOff className="w-3.5 h-3.5 text-amber-400" />
            <span>You're offline — showing saved data</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
